import { API } from '#lib/network/API';
import { VoPConsentStatus } from '#lib/network/api/vop/vop';

import { useGet } from '../useGet';
import { VoPKeys } from './VoP.keys';

export const useGetVoPConsentStatus = () => {
  const { isLoading, error, data } = useGet<VoPConsentStatus>(VoPKeys.consentStatus, API.vop.getConsentStatus);
  return {
    isLoading,
    error,
    consentStatus: data
  };
};
